export const API_URL = "https://powderblue-bear-942381.hostingersite.com/GRAVIT_API";

const env_api_url =
  process.env.REACT_APP_HRMS_API_URL ||
  process.env.REACT_APP_VITE_HRMS_API_URL ||
  process.env.VITE_HRMS_API_URL ||
  "https://hrms.ezyprojects.com:5070/api/public";

const env_org_id =
  process.env.REACT_APP_HRMS_ORG_ID ||
  process.env.REACT_APP_VITE_HRMS_ORG_ID ||
  process.env.VITE_HRMS_ORG_ID ||
  "77cdfab7-aab7-4654-be04-5c600322c6b9";

const rawUrl = (env_api_url || "https://hrms.ezyprojects.com:5070/api/public")
  .trim()
  .replace(/\/+$/, "");

export const HRMS_API_URL = rawUrl.endsWith("/api/public")
  ? rawUrl
  : rawUrl.endsWith("/api")
  ? `${rawUrl}/public`
  : `${rawUrl}/api/public`;

export const HRMS_ORG_ID = (env_org_id || "").trim();